import {Component, OnDestroy, OnInit} from '@angular/core';
import {environment} from "../environments/environment";
import {BdpkFileService} from "./bdpk-common/services/bdpk-file.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {

  constructor() {}

  ngOnInit(): void {
    console.log(environment);
  }

  ngOnDestroy(): void {

  }
}
